import * as languages from "../../sia-r109/rule.js";
import * as labelAndName from "../../sia-r14/rule.js";
import * as roleAndRequiredAttributes from "../../sia-r16/rule.js";
import * as withRoleAndName from "../../sia-r55/rule.js";
import * as sameNames from "../../sia-r56/rule.js";
import * as withFirstHeading from "../../sia-r61/rule.js";
import * as distinguishingStyles from "../../sia-r62/diagnostics.js";
import * as matchingClasses from "../../sia-r65/diagnostics.js";
import * as withDeclaration from "../../sia-r75/rule.js";
import * as clippingAncestors from "../../sia-r83/rule.js";
// R66, R69
import * as colorError from "../dom/get-colors.js";
// R17, R70, R90, R95, R42, R60, R68, R76, R91, R92, R93
import * as diagnostic from "../../common/diagnostic.js";
/**
 * @public
 */
export var Diagnostic;
(function (Diagnostic) {
    Diagnostic.Languages = languages.Languages;
    Diagnostic.LabelAndName = labelAndName.LabelAndName;
    Diagnostic.RoleAndRequiredAttributes = roleAndRequiredAttributes.RoleAndRequiredAttributes;
    Diagnostic.WithRoleAndName = withRoleAndName.WithRoleAndName;
    Diagnostic.SameNames = sameNames.SameNames;
    Diagnostic.WithFirstHeading = withFirstHeading.WithFirstHeading;
    Diagnostic.DistinguishingStyles = distinguishingStyles.DistinguishingStyles;
    Diagnostic.ElementDistinguishable = distinguishingStyles.ElementDistinguishable;
    Diagnostic.ColorError = colorError.ColorError;
    Diagnostic.ColorErrors = colorError.ColorErrors;
    Diagnostic.MatchingClasses = matchingClasses.MatchingClasses;
    Diagnostic.WithDeclaration = withDeclaration.WithDeclaration;
    Diagnostic.ClippingAncestors = clippingAncestors.ClippingAncestors;
    Diagnostic.Contrast = diagnostic.Contrast;
    Diagnostic.TextSpacing = diagnostic.TextSpacing;
    Diagnostic.WithBadElements = diagnostic.WithBadElements;
    Diagnostic.WithRole = diagnostic.WithRole;
    Diagnostic.WithName = diagnostic.WithName;
    Diagnostic.WithOtherHeading = diagnostic.WithOtherHeading;
    Diagnostic.WithBoundingBox = diagnostic.WithBoundingBox;
})(Diagnostic || (Diagnostic = {}));
//# sourceMappingURL=diagnostic.js.map